module.exports = __webpack_public_path__ + "img/sl_3.88452657.png";